interface Props {
  children: string
  className?: string
}

const NavItemPill = ({ children, className = "" }: Props) => (
  <span
    className={`shrink-0 px-1 py-0.5 rounded bg-[#786FF6] text-xs font-semibold uppercase tracking-wide text-white ${className}`}
  >
    {children}
  </span>
)

export default NavItemPill
